import AppDispatcher from '../dispatcher/AppDispatcher';
import { UPDATE_CURRENT_MESSAGE } from '../constants/AccessibilityConstants';

export function sayMessage(msg) {
  AppDispatcher.handleViewAction({
    actionType: UPDATE_CURRENT_MESSAGE,
    data: msg,
  });
}

export function sayLandingMessage(msg) {
  AppDispatcher.handleViewAction({
    actionType: UPDATE_CURRENT_MESSAGE,
    data: `You are on ${msg} page`,
  });
}
